module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEqSURBVEhL5dQ/S0JRHMbxm2JjQ0JRTkEJbgUubgUZ1NDi1NALiBp8CeILEKrN2UkaqpcQoYhELr2AIAcXl8Cpf9/neg8c7lCXOocGH/jgOUfP75x77/EGM500KrjCEB84gZOsoYdPSx1OksUz7OJd6IqcpAG7uGzDWeK7H2EB57jBBUr4dd4QXyBv9fX9GRKnDO2siiOYQrvRp07PYtR+wQ4SZQkHaEOTb3EYtW0TLOMaOgDfZg7H6CBeSLtbiY1JCxn8mBzuYCa+4xF6eK/RmK5KqcH8blUDSTKAJuieNrEOkz0U8Kezfo8nJHlIZveG83hfYB7eiivm3OtP5SWb0ALjsOchp9ACD2HPQ/rQApdhz3GKUHHZ0oDr7EPF9Yrwlg2kps1/TRB8AfONYzf/TYfEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-garden-shears/dark/24.png
// module id = 2110
// module chunks = 2